export default {
  GET_CITIES_LIST_LOADING: 'GET_CITIES_LIST_LOADING',
  GET_CITIES_LIST_SUCCESS: 'GET_CITIES_LIST_SUCCESS',
  GET_CITIES_LIST_FAILED: 'GET_CITIES_LIST_FAILED',
  GET_CITIES_LIST_REJECT: 'GET_CITIES_LIST_REJECT',

  GET_CITY_BY_ID_LOADING: 'GET_CITY_BY_ID_LOADING',
  GET_CITY_BY_ID_SUCCESS: 'GET_CITY_BY_ID_SUCCESS',
  GET_CITY_BY_ID_FAILED: 'GET_CITY_BY_ID_FAILED',
  GET_CITY_BY_ID_REJECT: 'GET_CITY_BY_ID_REJECT',

  UPDATE_CITY_LOADING: 'UPDATE_CITY_LOADING',
  UPDATE_CITY_SUCCESS: 'UPDATE_CITY_SUCCESS',
  UPDATE_CITY_FAILED: 'UPDATE_CITY_FAILED',
  UPDATE_CITY_REJECT: 'UPDATE_CITY_REJECT',

  ADD_NEW_CITY_LOADING: 'ADD_NEW_CITY_LOADING',
  ADD_NEW_CITY_SUCCESS: 'ADD_NEW_CITY_SUCCESS',
  ADD_NEW_CITY_FAILED: 'ADD_NEW_CITY_FAILED',
  ADD_NEW_CITY_REJECT: 'ADD_NEW_CITY_REJECT',
};